import axios from '../../../HttpRequests/axios';

export const FETCH_ORDER_BREAKDOWN_REQUEST = 'FETCH_ORDER_BREAKDOWN_REQUEST';
export const FETCH_ORDER_BREAKDOWN_SUCCESS = 'FETCH_ORDER_BREAKDOWN_SUCCESS';
export const FETCH_ORDER_BREAKDOWN_FAILURE = 'FETCH_ORDER_BREAKDOWN_FAILURE';

export default function fetchOrderBreakdown() {
  return (dispatch) => {
    dispatch({ type: FETCH_ORDER_BREAKDOWN_REQUEST });

    return axios
      .get('/dashboard/orders/breakdown')
      .then((response) => {
        dispatch({
          type: FETCH_ORDER_BREAKDOWN_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      })
      .catch((error) => {
        console.error('Order Breakdown Error:', error);
        dispatch({
          type: FETCH_ORDER_BREAKDOWN_FAILURE,
          payload: error.message || 'Failed to load order breakdown',
        });
        throw error;
      });
  };
}
